import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "container-categories" }
const _hoisted_2 = ["aria-pressed", "onClick", "onKeydown"]
const _hoisted_3 = { class: "category-title" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

import { CategoryItem } from '@/components/general/lists/ListMenuWithCheckbox/ListMenuWithCheckbox.vue'

interface EMITS {
  (e: 'onSelectCategory', id: string)
}
interface PROPS {
  categories: CategoryItem[]
  selectedCategoryId: string
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ListCategory',
  props: {
    categories: {},
    selectedCategoryId: {}
  },
  emits: ["onSelectCategory"],
  setup(__props: any) {





function numberOfSelectedTypes(category: CategoryItem) {
  return category.types.filter((type) => type.visible == true).length
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
      return (_openBlock(), _createElementBlock("div", {
        key: category.id,
        class: "category-box"
      }, [
        _createElementVNode("div", {
          "aria-pressed": category.id === _ctx.selectedCategoryId,
          class: _normalizeClass(["select-category", [category.id === _ctx.selectedCategoryId ? 'selected' : '']]),
          role: "button",
          tabindex: "0",
          onClick: () => _ctx.$emit('onSelectCategory', category.id),
          onKeydown: [
            _withKeys(() => _ctx.$emit('onSelectCategory', category.id), ["enter"]),
            _withKeys(() => _ctx.$emit('onSelectCategory', category.id), ["space"])
          ]
        }, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(category.name), 1),
          _createElementVNode("div", {
            class: _normalizeClass(["numbers-selected", [numberOfSelectedTypes(category) !== 0 ? 'more-numbers' : '']])
          }, [
            (numberOfSelectedTypes(category) !== 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(numberOfSelectedTypes(category)), 1))
              : _createCommentVNode("", true),
            (numberOfSelectedTypes(category) !== 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, " / "))
              : _createCommentVNode("", true),
            _createElementVNode("span", null, _toDisplayString(category.types.length), 1)
          ], 2)
        ], 42, _hoisted_2)
      ]))
    }), 128))
  ]))
}
}

})